import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChannelsFilter, selectUnreadMessages } from '../../../../../store/app.selectors';
import { BaseComponent } from '../../../../../modules/shared/components/base/base.component';
import { setAllChannelsLoaded, setLoadingChannels } from '../../../../shared/store/ui.actions';
import { IFilters } from '../../../interfaces/IWorkspace';
import { getUnreadMessages, loadChannels, setFilterValue } from '../../../store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../../store/chat.reducer';

@Component({
  selector: 'ngx-check-filter',
  templateUrl: './check-filter.component.html',
  styleUrls: ['./check-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckFilterComponent extends BaseComponent {
  @Input() check: IFilters;

  private store = inject(Store<AppStateWithChat>);

  channelsFilter = toSignal(this.store.select(selectChannelsFilter), { initialValue: chatInitialState.channelsFilter });
  unreadMessages = toSignal(this.store.select(selectUnreadMessages), { initialValue: 0 });
  unreads = computed(() => (this.check?.field === 'readStatus' ? this.unreadMessages() : 0));

  setValue(): void {
    const value = !this.check.value ? this.check.checkValue || true : false;
    this.store.dispatch(setFilterValue({ value, key: this.check.name }));
    this.store.dispatch(setLoadingChannels({ value: true }));
    this.store.dispatch(setAllChannelsLoaded({ value: false }));
    this.store.dispatch(
      loadChannels({
        autoSelectChannel: false,
        setLoading: true,
        concat: false,
      })
    );
    this.store.dispatch(getUnreadMessages());
  }
}
